import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import {provideRouter, withRouterConfig} from '@angular/router';
import { routes } from './app.routes';
import {HttpClientModule, provideHttpClient} from "@angular/common/http";
import { NgHttpLoaderModule } from 'ng-http-loader';
import { provideNgxMask } from 'ngx-mask';


export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideHttpClient(),
        provideNgxMask(),
        // importProvidersFrom( NgHttpLoaderModule.forRoot(),ImageViewerModule.forRoot()),
         importProvidersFrom(
      HttpClientModule,
      NgHttpLoaderModule.forRoot()
    ),
        provideRouter(routes)
    ],
};